/* eslint-disabled */
import Guarantee from "./Guarantee";
import Coverage from "./Coverage";
import RiskExtend from "@/entity/extends/RiskExtend";
import {helper} from "@/services/Helper";

export default class Risk extends RiskExtend {

    public id!: number;
    public uuid = helper.generateId()
    public label = '';
    public icon? = '';
    public description? = '';
    public max?: number;
    public maxDescription? = '';
    public min?: number;
    public minDescription? = '';
    public guarantee!: Guarantee;
    public isOptional?: boolean;
    public premium!: number;
    public coverage!: Coverage;

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.label = object.label;
            this.icon = object.icon;
            this.description = object.description;
            this.max = object.max;
            this.maxDescription = object.maxDescription;
            this.min = object.min;
            this.minDescription = object.minDescription;
            this.guarantee = (object.guarantee instanceof Guarantee) ? object.guarantee : object.guarantee ? new Guarantee(object.guarantee) : object.guarantee;
            this.isOptional = object.isOptional;
            this.premium = object.premium;
            this.coverage = (object.coverage instanceof Coverage) ? object.coverage : object.coverage ? new Coverage(object.coverage) : object.coverage;
            this.uuid = object.uuid
        }
        this.postConstruct()
    }

}
